import { render, staticRenderFns } from "./CreateAccountPage.vue?vue&type=template&id=29d5a5f0"
import script from "./CreateAccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAccountPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateAccountPage.vue?vue&type=style&index=0&id=29d5a5f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports